/**
 * Abstract creator score system.
 * Score slots only — no calculation logic.
 */
export interface CreatorScoreModel {
  visibilityScore: number;
  engagementScore: number;
  monetizationScore: number;
  /** Reserved for future trust / moderation signals. */
  trustScore: number;
}

export function createEmptyCreatorScoreModel(): CreatorScoreModel {
  return {
    visibilityScore: 0,
    engagementScore: 0,
    monetizationScore: 0,
    trustScore: 0,
  };
}

/** Describes what each score dimension represents in the product loop. */
export const CREATOR_SCORE_DEFINITIONS: Readonly<Record<keyof CreatorScoreModel, string>> = {
  visibilityScore: 'Feed exposure and discovery potential',
  engagementScore: 'Audience interaction quality and volume',
  monetizationScore: 'Commerce and earnings performance',
  trustScore: 'Platform safety and credibility (future)',
};
